import { Search } from '@mui/icons-material';
import { Box, Input } from '@mui/material';

import { useDebouncedCallback } from '@/hooks';
import { AnalyticsService, EVENTS } from '@/services';
import { TYPOGRAPHY } from '@/theme';

export const SearchBar = ({
  setSearchTerm,
}: {
  setSearchTerm: (term: string) => void;
}) => {
  const debouncedSearch = useDebouncedCallback((term: string) => {
    setSearchTerm(term);
    AnalyticsService.logEvent(EVENTS.TRACKER_EVENTS.SEARCH_USED, {
      query: term,
    });
  }, 200);
  return (
    <Box
      sx={{
        width: '100%',
        maxWidth: 700,
        height: 48,
        bgcolor: 'grey50',
        px: 2,
        display: 'flex',
        alignItems: 'center',
        borderRadius: 16,
        gap: 0.5,
      }}>
      <Search sx={{ width: 20, height: 20 }} />
      <Input
        disableUnderline
        fullWidth
        sx={{
          ...TYPOGRAPHY.body3,
        }}
        onChange={e => {
          debouncedSearch(e.target.value);
        }}
        placeholder={'Search Certificates...'}
      />
    </Box>
  );
};
